import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  RevenueReport,
  RevenueReportGuard,
} from "@/features/office/reports/revenue";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). Filter state follows the shared `filters-new` chip DSL.
const searchSchema = z.object({
  search: z.string().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  // "UTC", or absent for ET; anything else reads as ET.
  timeZone: z.string().optional().catch(undefined),
  filters: z
    .object({
      accountId: withOperators(commaListSchema),
      movement: withOperators(commaListSchema),
      // "true" / "false" from the boolean widget, "" while the chip waits for a
      // value; lenient, so a hand-typed value cannot crash the page.
      isAdjustment: withOperators(z.string().optional()),
      ...notificationSearchFragment,
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const routeId = "/office/reports/revenue";
export const Route = createFileRoute("/office/reports/revenue")({
  validateSearch: searchSchema,
  component: RevenueReportPage,
});

/** Gate + role guarded: the rollout flag and the platform's ADMIN/MANAGER rule. */
function RevenueReportPage() {
  return (
    <RevenueReportGuard>
      <RevenueReport />
    </RevenueReportGuard>
  );
}
